import { InjectionToken } from "@angular/core";

/**
 * Allows for the browser's standard `location` API to be injected instead of directly accessed to facilitate testing.
 * @see https://stackoverflow.com/questions/68390190/angular-how-to-test-window-location-href-with-jasmine-karma/72516638#72516638
 */
export const WINDOW = new InjectionToken<Window>(
    "Global Window API",
    {
        providedIn: "root",
        factory: () => window
    });

/**
 * Allows for the browser's standard `location` API to be injected instead of directly accessed to facilitate testing.
 * @see https://stackoverflow.com/questions/68390190/angular-how-to-test-window-location-href-with-jasmine-karma/72516638#72516638
 */
export const LOCATION = new InjectionToken<Location>(
    "Global Location API",
    {
        providedIn: "root",
        factory: () => location
    });
